import { useState } from 'react'

import type { Gebied } from '@models/Gebied'

import { useCombiOpdrachtenSearchStore } from '../../../../opdrachten/combi/hooks/useCombiOpdrachtenSearchStore'
import { initialState as initialStateCombiOpdrachten } from '../../../../opdrachten/combi/services/searchCombiOpdrachten'
import { useNavigate } from '../../../../router/hooks/useNavigate'
import type { ActiviteitTemplate } from '../../../../templates/types/ActiviteitTemplate'
import type { OptionsDialogData } from '../../types/OptionsDialogData'
import type { Project } from '../../types/Project'

import { ProjectOptionsDialog } from './ProjectOptionsDialog'
import { ProjectOptionsMenu } from './ProjectOptionsMenu'

interface Props {
  project: Project
  anchorEl?: HTMLElement
  setAnchorEl: (anchor?: HTMLElement) => void
  gebieden: Gebied[]
  activiteitTemplates: ActiviteitTemplate[]
  selectableLabels: string[]
}

export const ProjectOptions = ({
  project,
  anchorEl,
  setAnchorEl,
  gebieden,
  activiteitTemplates,
  selectableLabels,
}: Props) => {
  const navigate = useNavigate()
  const { storeQuery: storeQueryCombiOpdrachten } =
    useCombiOpdrachtenSearchStore()
  const [type, setType] = useState<OptionsDialogData['type']>()

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const onOpenDialog = (data: OptionsDialogData) => {
    setIsDialogOpen(true)
    setType(data.type)
  }

  const onCloseDialog = () => {
    setIsDialogOpen(false)
  }

  const onNavigateToOpdrachten = ({ aanvraagID }) => {
    storeQueryCombiOpdrachten({
      filters: {
        ...initialStateCombiOpdrachten.query.filters,
        search: aanvraagID,
      },
      sort: initialStateCombiOpdrachten.query.sort,
      page: initialStateCombiOpdrachten.query.page,
    })
    navigate('/combiopdrachten')
  }

  return (
    <>
      <ProjectOptionsMenu
        project={project}
        onClose={() => setAnchorEl(undefined)}
        anchorEl={anchorEl}
        onOpenDialog={onOpenDialog}
        onNavigateToOpdrachten={onNavigateToOpdrachten}
        selectableLabels={selectableLabels}
      />
      <ProjectOptionsDialog
        open={isDialogOpen}
        onClose={onCloseDialog}
        project={project}
        type={type}
        gebieden={gebieden}
        activiteitTemplates={activiteitTemplates}
        selectableLabels={selectableLabels}
      />
    </>
  )
}
